import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2c55fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"margin-right":"10px","color":"#4f6bff"} }
const _hoisted_3 = { style: {"margin-right":"10px","color":"#4f6bff"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_a_time_picker = _resolveComponent("a-time-picker")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("customermanagement")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.usermanagement}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("userlist")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isEdit === "1" ? _ctx.t("edituser") : _ctx.t("newuser")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, {
      model: _ctx.costomerForm,
      class: "form",
      rules: _ctx.rules,
      "label-col": _ctx.labelCol
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: _ctx.t('customertype'),
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              value: _ctx.costomerForm.type,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.costomerForm.type) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: '1' }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("internationalusers")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: '2' }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("domesticusers")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('username'),
          name: "username",
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.costomerForm.username,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.costomerForm.username) = $event)),
              placeholder: _ctx.t('inputusername')
            }, null, 8, ["value", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('tel'),
          name: "phone",
          ref: "name",
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.costomerForm.country_code,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.costomerForm.country_code) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.country_code_list, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.id,
                            value: item.code,
                            "onUpdate:value": ($event: any) => ((item.code) = $event)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.code + item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "onUpdate:value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_input, {
                  value: _ctx.costomerForm.phone,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.costomerForm.phone) = $event)),
                  style: {"width":"50%"},
                  placeholder: _ctx.t('inputtel')
                }, null, 8, ["value", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('customer')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.costomerForm.org_ids,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.costomerForm.org_ids) = $event)),
              placeholder: _ctx.t('pleaseentervenueinformation'),
              mode: "multiple",
              allowClear: "",
              showSearch: "",
              "filter-option": _ctx.filterOption
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.org_user_list, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.org_id,
                    value: item.org_id,
                    "onUpdate:value": ($event: any) => ((item.org_id) = $event),
                    label: item.organization_name
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.organization_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "placeholder", "filter-option"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('agent')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.agent_info.agent_name), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('language'),
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.costomerForm.language,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.costomerForm.language) = $event)),
              placeholder: _ctx.t('pleaseentervenueinformation'),
              allowClear: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.language, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.value,
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('userrole')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.costomerForm.roles.role_id,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.costomerForm.roles.role_id) = $event)),
              placeholder: _ctx.t('selectrole'),
              allowClear: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allrole_list, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.id,
                    value: item.id,
                    "onUpdate:value": ($event: any) => ((item.id) = $event)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('messageswitch')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_switch, {
              checked: _ctx.costomerForm.message_switch,
              "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.costomerForm.message_switch) = $event))
            }, null, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('dutyhours')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("starttime")) + "：", 1),
            _createVNode(_component_a_time_picker, {
              value: _ctx.costomerForm.duty_start,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.costomerForm.duty_start) = $event)),
              "value-format": "HH:mm"
            }, {
              suffixIcon: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_CalendarOutlined)
                ])
              ]),
              _: 1
            }, 8, ["value"]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("endtime")) + "： ", 1),
            _createVNode(_component_a_time_picker, {
              value: _ctx.costomerForm.duty_end,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.costomerForm.duty_end) = $event)),
              "value-format": "HH:mm"
            }, {
              suffixIcon: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_CalendarOutlined)
                ])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('usercomments')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: _ctx.costomerForm.remark,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.costomerForm.remark) = $event)),
              placeholder: _ctx.t('remark')
            }, null, 8, ["value", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "rules", "label-col"]),
    _createVNode(_component_a_button, {
      style: {"margin":"0% 20px 0 40%"},
      onClick: _ctx.cancel
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("cancellation")), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _ctx.onSubmit,
      "html-type": "submit",
      style: {"background-color":"#4f6bff"}
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("submit")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}